import { render } from "./PagePacienteDependente.vue?vue&type=template&id=73b5b6b0&scoped=true"
import script from "./PagePacienteDependente.vue?vue&type=script&lang=js"
export * from "./PagePacienteDependente.vue?vue&type=script&lang=js"

import "./PagePacienteDependente.vue?vue&type=style&index=0&id=73b5b6b0&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b5b6b0"]])

export default __exports__